/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropwinnersmessagetitle3Inputs */

const en_dropwinnersmessagetitle3 = /** @type {(inputs: Dropwinnersmessagetitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Winner message`)
};

const de_dropwinnersmessagetitle3 = /** @type {(inputs: Dropwinnersmessagetitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewinner-Nachricht`)
};

/**
* | output |
* | --- |
* | "Winner message" |
*
* @param {Dropwinnersmessagetitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropwinnersmessagetitle3 = /** @type {((inputs?: Dropwinnersmessagetitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropwinnersmessagetitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropwinnersmessagetitle3(inputs)
	return de_dropwinnersmessagetitle3(inputs)
});
export { dropwinnersmessagetitle3 as "dropWinnersMessageTitle" }